export default __webpack_public_path__ + "static/media/logo_new.92f03d84.png";